'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var statusChangeToError = exports.statusChangeToError = function statusChangeToError(message, statusChange) {
  var error = new Error(message);
  error.responseText = statusChange.reason.toString();
  return error;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-pub-sub/static-1.4265/js/ably/operators/statusChangeToError.js
// module id = 779
// module chunks = 2 3